(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-b2b-quick-order"] && !Shopify.designMode) return;
  try {
    
  class SvB2BOrderView extends HTMLElement {
    connectedCallback() {
      const gridResults = document.querySelector('[data-sv-b2b-grid]');
      this.grid = gridResults?.closest('collection-component') || gridResults;
      this.panel = this.querySelector('[data-quick-panel]');
      this.form = this.querySelector('[data-quick-form]');
      this.buttons = [...this.querySelectorAll('[data-view]')];
      this.inputs = [...this.querySelectorAll('[data-variant-id]')];
      this.message = this.querySelector('[data-order-message]');
      this.submitButton = this.querySelector('[type="submit"]');

      this.buttons.forEach((button) => button.addEventListener('click', () => this.setView(button.dataset.view)));
      this.inputs.forEach((input) => input.addEventListener('input', () => this.updateSummary()));
      this.form?.addEventListener('submit', (event) => this.submit(event));
      this.querySelectorAll('[data-media-preview]').forEach((preview) => {
        const video = preview.querySelector('video');
        if (!video) return;

        const play = () => video.play().catch(() => {});
        const stop = () => {
          video.pause();
          video.currentTime = 0;
        };

        preview.addEventListener('mouseenter', play);
        preview.addEventListener('mouseleave', stop);
      });
    }

    setView(view) {
      const showQuick = view === 'quick';
      this.panel.hidden = !showQuick;
      if (this.grid) this.grid.hidden = showQuick;
      this.buttons.forEach((button) => button.setAttribute('aria-selected', String(button.dataset.view === view)));
    }

    selectedItems() {
      return this.inputs
        .map((input) => ({
          id: input.dataset.variantId,
          quantity: Number.parseInt(input.value, 10) || 0,
          price: Number(input.dataset.price) || 0,
          minimum: Number(input.dataset.minimum) || 1,
          increment: Number(input.step) || 1,
          input,
        }))
        .filter((item) => item.quantity > 0);
    }

    updateSummary() {
      const items = this.selectedItems();
      const units = items.reduce((sum, item) => sum + item.quantity, 0);
      const total = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
      const currency = new Intl.NumberFormat(document.documentElement.lang || 'cs-CZ', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'CZK',
      });

      this.querySelector('[data-total-units]').textContent = units;
      this.querySelector('[data-total-price]').textContent = currency.format(total / 100);
      this.submitButton.disabled = units === 0;
      this.message.textContent = '';
    }

    async submit(event) {
      event.preventDefault();
      const items = this.selectedItems();
      const invalid = items.find((item) => item.quantity < item.minimum || (item.quantity - item.minimum) % item.increment !== 0);

      if (invalid) {
        invalid.input.focus();
        this.message.textContent = this.dataset.invalidMessage;
        return;
      }

      this.submitButton.disabled = true;
      this.message.textContent = '';

      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map(({ id, quantity }) => ({ id, quantity })) }),
        });

        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.message.textContent = this.dataset.errorMessage;
        this.submitButton.disabled = false;
      }
    }
  }

  if (!customElements.get('sv-b2b-order-view')) {
    customElements.define('sv-b2b-order-view', SvB2BOrderView);
  }

  } catch(e) { console.error(e); }
})();
})();
